export const PARAMS = {
  tag: "tag",
  all: "all",
  query: "q"
}
